import React, { useState } from "react";
import StarRating from "../common/StarRating";

function ProductCard({ product, language, t, onClick }) {
  const [isFavorite, setIsFavorite] = useState(false);

  const toggleFavorite = () => {
    setIsFavorite(!isFavorite);
  };

  return (
    <div className='col-6 col-md-4' onClick={onClick}>
      <div className='product_card'>
        <div className={`image ${product?.images[0]?.has_background == 1 ? "full_width" : ""}`}>
          <img
            src={product?.images[0]?.image_path}
            alt=''
            className={product?.images[0]?.has_background == 1 ? "full_width_img" : ""}
          />
        </div>

        <div className='card_details'>
          <div className='star'>
            <StarRating rating={3} />
          </div>
          <div
            className='title'
            title={language === "ar" ? product.name_ar ?? "اسم المنتج" : product.name_en ?? "product name"}>
            {language === "ar" ? product.name_ar ?? "اسم المنتج" : product.name_en ?? "product name"}
          </div>

          <div
            className='desc'
            dangerouslySetInnerHTML={{
              __html:
                language === "ar"
                  ? product.description_ar?.replace(/\n/g, "<br />") ?? "وصف المنتج"
                  : product.description_en?.replace(/\n/g, "<br />") ?? "product description",
            }}
          />
          <button>{t("add_to_cart")}</button>
        </div>
        <div className='fav_container' onClick={toggleFavorite}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/white/${isFavorite ? "love" : "empty_love"}.svg`}
            alt={isFavorite ? "Remove from favorites" : "Add to favorites"}
          />
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
